import { render, staticRenderFns } from "./ExperienciaList.vue?vue&type=template&id=07c0b102"
import script from "./ExperienciaList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienciaList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports